
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
    },
  
    table: {
      backgroundColor: '#dcdcdc',
      padding: '1%',
      margin:'0.1%'
    },
  
    items: {
      padding: '1%',
    },
  
    item_header: {
      fontSize: '120%',
      fontWeight: 600,
      paddingLeft: '10%',
    },
  
    item_body: {
      padding: '6px ',

    },
  
    main_header: {
      padding: '1%',
      marginBottom: '3%',
      backgroundColor: '#32B6A7',
    },
  
    button_submit: {
      padding: '1%',
      justifyContent: 'center',
      display: 'flex',
      paddingTop: '6%',
    },
  
    input: {
      width: '50%',
    },
  
    success: {
      textAlign: 'center',
      fontSize: '120%',
      fontWeight: 800,
    }
  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerBulkbooking/style.js